import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-events',
    imports: [],
    templateUrl: './events.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './events.component.scss'
})
export class EventsComponent {

}
